import { IUpcomingDatas } from '.';

export const inPipeline: IUpcomingDatas[] = [
  {
    status: 'in-pipeline',
    progress: 0,
    imageURL: '',
    en: {
      title: `List ICP
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $ICP 📈✨

・ICP / USDT
・ICP / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List ICP
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $ICP 📈✨

・ICP / USDT
・ICP / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List ICP
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $ICP 📈✨

・ICP / USDT
・ICP / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'in-pipeline',
    progress: 0,
    imageURL: '',
    en: {
      title: `FX<->Ultorex Spot Balance Transfer`,
      content: `#Ultorex now supporst the transfer of funds to and from your spot and FX wallet.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `FX<->Ultorex Spot Balance Transfer`,
      content: `#Ultorex now supporst the transfer of funds to and from your spot and FX wallet.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `FX<->Ultorex Spot Balance Transfer`,
      content: `#Ultorex now supporst the transfer of funds to and from your spot and FX wallet.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'in-pipeline',
    progress: 0,
    imageURL: '',
    en: {
      title: `Auto Restake Function`,
      content: ``,
      learnMoreUrl: '#',
    },
    tr: {
      title: `Auto Restake Function`,
      content: ``,
      learnMoreUrl: '#',
    },
    zh: {
      title: `Auto Restake Function`,
      content: ``,
      learnMoreUrl: '#',
    },
  },

  {
    status: 'in-pipeline',
    progress: 0,
    imageURL: '',
    en: {
      title: `List VET & IMX
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $VET and $IMX📈✨

・VET / USDT  ・VET / BTC
・IMX / USDT  ・IMX / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List VET & IMX
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $VET and $IMX📈✨

・VET / USDT  ・VET / BTC
・IMX / USDT  ・IMX / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List VET & IMX
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $VET and $IMX📈✨

・VET / USDT  ・VET / BTC
・IMX / USDT  ・IMX / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },

  {
    status: 'in-pipeline',
    progress: 0,
    imageURL: '',
    en: {
      title: `List KP3R & YGG
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $KP3R and $YGG📈✨

・KP3R / USDT  ・KP3R / BTC
・YGG / USDT   ・YGG / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List KP3R & YGG
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $KP3R and $YGG📈✨

・KP3R / USDT  ・KP3R / BTC
・YGG / USDT   ・YGG / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List KP3R & YGG
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $KP3R and $YGG📈✨

・KP3R / USDT  ・KP3R / BTC
・YGG / USDT   ・YGG / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },

  {
    status: 'in-pipeline',
    progress: 0,
    imageURL: '',
    en: {
      title: `List CRV & YFI
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $CRV and $YFI📈✨

・CRV / USDT ・CRV / BTC
・YFI / USDT   ・YFI / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List CRV & YFI
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $CRV and $YFI📈✨

・CRV / USDT ・CRV / BTC
・YFI / USDT   ・YFI / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List CRV & YFI
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $CRV and $YFI📈✨

・CRV / USDT ・CRV / BTC
・YFI / USDT   ・YFI / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },

  {
    status: 'in-pipeline',
    progress: 0,
    imageURL: '',
    en: {
      title: `Reminder for Deposits/ Withdrawals on chain are not stable.`,
      content: ``,
      learnMoreUrl: '#',
    },
    tr: {
      title: `Reminder for Deposits/ Withdrawals on chain are not stable.`,
      content: ``,
      learnMoreUrl: '#',
    },
    zh: {
      title: `Reminder for Deposits/ Withdrawals on chain are not stable.`,
      content: ``,
      learnMoreUrl: '#',
    },
  },
];
